import { useQuery } from '@gogame/query';

import { loadOutsourceStudios } from 'scenes/Gallery/GalleryPage/OutsourceStudios/sources/outsourceStudio';

import { list } from './queryKeyFactory';

export const useOutsourceStudioList = () => {
  return useQuery(list(), (_, { signal }) =>
    loadOutsourceStudios({}, { signal })
  );
};
